import React from 'react'
import StyledLinearProgress from '../StyledLinearProgress'

export const LinearDeterminate = (props) => {
  const [completed, setCompleted] = React.useState(0)

  React.useEffect(() => {
    function progress() {
      setCompleted((oldCompleted) => {
        if (oldCompleted === 100) {
          return 100
        }
        const diff = Math.random() * 7
        return Math.min(oldCompleted + diff, 100)
      })
    }

    const timer = setInterval(progress, 500)
    return () => {
      clearInterval(timer)
    }
  }, [])

  return (
    <StyledLinearProgress {...props} variant="determinate" value={completed} />
  )
}
